
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { StatisticBook } from '../CeSystimeauthorinfoIbookusageperhourandweekday.vue';
import Accordion from '@/components/ui/accordion/Accordion.vue';

@Component({
  components: { Accordion }
})
export default class AuthorInfoIbookUsagePerHourItem extends Vue {
  @Prop({
    type: Object as PropType<StatisticBook>,
    default: () => {}
  })
  item!: StatisticBook;

  @Prop({ type: String as PropType<any[]> })
  type!: string;
  accordionExpanded: boolean = false;

  get labels(): any {
    return this.$attrs.template.labels;
  }

  renderContent() {
    this.accordionExpanded = !this.accordionExpanded;
  }
}
